<template>
<section class="vpn-section vpn-section--alt trust">
  <div class="vpn-section__inner">
    <h2 class="vpn-section__title">{{ reviewsTitle }}</h2>
    <p class="vpn-section__lead">{{ reviewsLead }}</p>
    <div class="trust__track" ref="track">
      <article v-for="item in reviewList" :key="item.name" class="trust__card">
        <div class="trust__head">
          <div class="trust__avatar" aria-hidden="true">{{ item.name.charAt(0) }}</div>
          <div>
            <div class="trust__name">{{ item.name }}</div>
            <div class="trust__stars" aria-label="5 stars">★★★★★</div>
          </div>
        </div>
        <p class="trust__text">“{{ item.text }}”</p>
      </article>
    </div>
  </div>
</section>
</template>

<script>
import homeLocaleContent from '@/mixins/homeLocaleContent';

export default {
  name: 'TestimonialsSection',
  mixins: [homeLocaleContent],
  computed: {
    reviewsTitle() {
      return this.homeLocale?.reviewsTitle || 'Why Users Trust Secure VPN';
    },
    reviewsLead() {
      return (
        this.homeLocale?.reviewsLead ||
        'Secure VPN helps users around the world enjoy a safer and more private internet experience. With fast connections, reliable servers, and easy-to-use features, it supports everyday activities like browsing, streaming, gaming, and using public Wi-Fi securely.'
      );
    },
    reviewList() {
      return this.homeLocale?.reviews || this.defaultReviews;
    },
  },
  data() {
    return {
      defaultReviews: [
        {
          name: 'James',
          text: 'Easy to use and connects fast. Secure VPN helps me browse safely wherever I am.',
        },
        {
          name: 'Emily',
          text: 'I use Secure VPN on public Wi-Fi regularly. The connection is stable and reliable.',
        },
        {
          name: 'Daniel',
          text: 'Great performance with smooth speeds for streaming, gaming, and everyday browsing.',
        },
      ],
    }
  },
}
</script>

<style lang="scss" scoped>
@import '@/css/vpn-sections.scss';

.trust {
  .vpn-section__title,
  .vpn-section__lead {
    text-align: left;
    max-width: none;
    margin-left: 0;
    margin-right: 0;
  }
}

.trust__track {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 18px;
}

.trust__card {
  background: #fff;
  border-radius: 16px;
  padding: 22px;
  border: 1px solid var(--vpn-line, #e8e4f8);
  box-shadow: 0 10px 28px rgba(109, 74, 255, 0.07);
}

.trust__head {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 14px;
}

.trust__avatar {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: var(--vpn-brand-grad, linear-gradient(135deg, #8a3ffc, #3e54e8));
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 18px;
}

.trust__name {
  font-size: 16px;
  font-weight: 600;
  color: var(--vpn-ink, #1f2430);
}

.trust__stars {
  font-size: 13px;
  color: #f5b400;
  letter-spacing: 1px;
  line-height: 1.2;
}

.trust__text {
  margin: 0;
  color: #6b7280;
  font-size: 14px;
  line-height: 1.6;
}

@media (max-width: 900px) {
  .trust__track {
    display: flex;
    overflow-x: auto;
    gap: 14px;
    padding-bottom: 8px;
    scroll-snap-type: x mandatory;
    -webkit-overflow-scrolling: touch;
  }

  .trust__card {
    flex: 0 0 min(280px, 78vw);
    min-width: 0;
    scroll-snap-align: start;
    padding: 18px;
  }
}

@media (max-width: 560px) {
  .trust__card {
    flex-basis: min(260px, 82vw);
  }
}
</style>
